import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromMutationObserver } from '@ux-aspects-universal/angular/utils';
import { Subject, merge } from 'rxjs';

/**
 * This is very similar to the CDK directionality service,
 * however the CDK does not take into account changes to
 * document direction after the service is initialised.
 */
class UxaDirectionality {
  constructor() {
    this._document = inject(DOCUMENT);
    this._destroyRef = inject(DestroyRef);
    /** The current direction */
    this.dir = this.getDirection();
    /** Emit whenever the direction changes */
    this.dirChange$ = new Subject();
    this.listenForDirectionChanges();
  }
  listenForDirectionChanges() {
    const config = {
      attributes: true,
      attributeFilter: ['dir']
    };
    // listen for any `dir` changes on the document or body
    merge(fromMutationObserver(this._document.body, config), fromMutationObserver(this._document.documentElement, config)).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      const newDirection = this.getDirection();
      if (this.dir !== newDirection) {
        this.dir = newDirection;
        this.dirChange$.next(newDirection);
      }
    });
  }
  /**
   * Get the direction of the document
   */
  getDirection() {
    // the body direction takes priority over the html direction as it is lower in the DOM tree
    const direction = this._document.body.dir || this._document.documentElement.dir;
    // provide a fallback to ltr if the direction is set to `auto`
    return direction === 'ltr' || direction === 'rtl' ? direction : 'ltr';
  }
  static {
    this.ɵfac = function UxaDirectionality_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaDirectionality)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UxaDirectionality,
      factory: UxaDirectionality.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaDirectionality, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { UxaDirectionality };
